export default __webpack_public_path__ + "static/media/five_icon22.e43a5910.png";